<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
  html,body{
    height: 100%;
  }
  #app{
    font-family:"Noto Sans CJK SC", "Source Han Sans CN";
    height: 100%;
  }
  .container{
    width: 100%;
  }
  a{  text-decoration: none;  }
  a:link{text-decoration:none;}
  a:visited{text-decoration:none;}
  a:active{text-decoration:none;}
  ul,li{
    list-style:none;
    font-weight: normal;
  }
  .lf{float:left;}
  .rt{float:right;}
  .clear:after{
    display: block;
    content: '';
    clear: both;
  }
  .topCarousel{
    width: 100%;
    min-width: 1200px;
  }
  .topCarousel>img{
    display: block;
    width: 100%;
  }
  .content-title{
    font-size:24px;
    color:#666666;
    text-align:center;
    position: relative;
    padding-top: 55px;
    padding-bottom: 20px;
  }
  .content-title:after{
    display: block;
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -19px;
    bottom: 0;
    width: 38px;
    height: 3px;
    background-color: #C01726;
  }
  .hot{
    position: relative;
    padding-right: 12px;
  }
  .hot:after{
    content: '';
    width: 12px;
    height: 100%;
    display: block;
    background: url("./assets/home/hot.png") no-repeat 0 center;
    background-size: 100% auto;
    position: absolute;
    right: 0;
    top: 0;
  }
  .contentBox {
    width: 1200px;
    margin: 0 auto;
  }

  .textP{
    margin:  15px 0;
    text-align: justify;
    text-indent: 2em;
    font-size: 16px;
    line-height: 30px;
    color:#333333;
    letter-spacing:2px;
  }
  .textP-inline{
    text-align: justify;
    text-indent: 2em;
    font-size: 16px;
    line-height: 30px;
    color:#333333;
    letter-spacing:2px;
  }
  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
    background-color: rgba(16,20,22,0.5) !important;
  }
  .el-loading-mask.is-fullscreen .el-loading-spinner .circular{
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue